import { LucideX } from "lucide-react";
import { ReactNode } from "react";
import { cn } from "../../util/base.util";

export default function ConfirmationModal({children, onOk, onCancel, ...props}: {
    children: ReactNode;
    okText?: ReactNode;
    cancelText?: ReactNode;
    onOk?: () => void;
    onCancel?: () => void;
    dangerous?: boolean;
}) {
    return (
        <div className="modal modal-open">

            <div className="modal-box p-2 max-w-sm">
                <div className="flex items-center justify-end gap-2">
                    <div>
                        <button onClick={onCancel} className="btn btn-sm btn-circle btn-ghost"><LucideX size={16} /></button>
                    </div>
                </div>

                {children}

                <div className="modal-action">
                    <button onClick={onOk} className={cn(
                        "btn btn-sm",
                        props.dangerous ? "btn-error" : "btn-primary"
                    )}>{props.okText ?? "Ok"}</button>
                    <button onClick={onCancel} className="btn btn-sm btn-ghost">{props.cancelText ?? "Cancel"}</button>
                </div>
            </div>

            <label onClick={onCancel} className="modal-backdrop"></label>
        </div>
    );
}